(() => {
  const SECTION_SELECTOR = "#geometry-section";
  const NAV_SELECTOR = ".geometry-nav";
  const PANEL_SELECTOR = ".geometry-block";
  const OVERVIEW_PANEL_ID = "back_to_geometry_overview";

  function getToggleControls(navElement) {
    return Array.from(navElement.querySelectorAll("button[name], a[name]"));
  }

  function setPanelState(panel, isActive) {
    panel.classList.toggle("visually-hidden", !isActive);
    panel.toggleAttribute("hidden", !isActive);
    panel.setAttribute("aria-hidden", isActive ? "false" : "true");
    panel.tabIndex = isActive ? 0 : -1;
  }

  function activatePanel(section, navElement, targetId, focusPanel = false) {
    const controls = getToggleControls(navElement);
    const panels = Array.from(section.querySelectorAll(PANEL_SELECTOR));
    const activePanel = section.querySelector(`#${CSS.escape(targetId)}`);
    const backControl = controls.find(
      (control) => control.name === OVERVIEW_PANEL_ID,
    );

    if (!activePanel) return;
    const panelWasHidden =
      activePanel.hasAttribute("hidden") ||
      activePanel.classList.contains("visually-hidden");

    controls.forEach((control) => {
      const isActive = control.name === targetId;
      control.setAttribute("aria-selected", isActive ? "true" : "false");
      control.setAttribute("aria-current", isActive ? "true" : "false");
      control.setAttribute("aria-disabled", isActive ? "true" : "false");
      control.toggleAttribute("disabled", isActive);
      control.classList.toggle("is-active", isActive);
      control.classList.toggle("disabled", isActive);
      control.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    if (backControl) {
      const showBackControl = targetId !== OVERVIEW_PANEL_ID;
      backControl.classList.toggle("visually-hidden", !showBackControl);
      backControl.toggleAttribute("hidden", !showBackControl);
      backControl.setAttribute(
        "aria-hidden",
        showBackControl ? "false" : "true",
      );
      if (!showBackControl) {
        backControl.setAttribute("tabindex", "-1");
      }
    }

    panels.forEach((panel) => {
      setPanelState(panel, panel.id === targetId);
    });

    if (panelWasHidden) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.dispatchEvent(new Event("resize"));
        });
      });
    }

    if (focusPanel) {
      activePanel.focus({ preventScroll: false });
    }
  }

  function initializeSection(section) {
    const navElement = section.querySelector(NAV_SELECTOR);
    if (!navElement) return;

    const controls = getToggleControls(navElement);
    if (!controls.length) return;

    const initialControl =
      controls.find(
        (control) => control.getAttribute("aria-selected") === "true",
      ) || controls[0];

    if (initialControl?.name) {
      activatePanel(section, navElement, initialControl.name, false);
    }

    navElement.addEventListener("click", (event) => {
      const control = event.target.closest("button[name], a[name]");
      if (!control || !navElement.contains(control)) return;

      if (control.tagName === "A") {
        event.preventDefault();
      }

      if (control.name) {
        activatePanel(section, navElement, control.name, false);
      }
    });

    navElement.addEventListener("keydown", (event) => {
      const currentControl = event.target.closest("button[name], a[name]");
      if (!currentControl || !navElement.contains(currentControl)) return;

      const availableControls = controls.filter((control) => !control.hidden);

      const currentIndex = availableControls.indexOf(currentControl);
      if (currentIndex === -1) return;

      let nextIndex = null;
      if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        nextIndex = (currentIndex + 1) % availableControls.length;
      } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        nextIndex =
          (currentIndex - 1 + availableControls.length) %
          availableControls.length;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = availableControls.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      const nextControl = availableControls[nextIndex];
      if (!nextControl?.name) return;

      activatePanel(section, navElement, nextControl.name, false);
      nextControl.focus();
    });
  }

  function initializeGeometryToggle() {
    const sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach((section) => initializeSection(section));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeGeometryToggle, {
      once: true,
    });
  } else {
    initializeGeometryToggle();
  }
})();
